import { useEffect } from 'react';

// Drops the static index.html skeleton (see index.html) once real app content is ready to render.
export const useRemoveAppSkeleton = (ready = true) => {
  useEffect(() => {
    if (ready) {
      document.querySelector('.app-skeleton')?.remove();
    }
  }, [ready]);
};

export default useRemoveAppSkeleton;
